import React, { Fragment, useCallback } from 'react';
import './Bonus.css';
import Store from '../Store/Store';
import Comment from '../Comment/Comment';
import EmployeeInfo from '../EmployeeInfo/EmployeeInfo';
import { useContext, useState } from 'react';
import CbmContext from '../../Context/Cbm/cbmContext';
import ValidationErrors from '../Utils/ValidationErrors';
import useFormSetup from '../../hooks/useFormSetup';
import { findStoreById } from '../Utils/helperFuncs';

const Bonus = ({ setPayLoad, setFormError, errMsg }) => {
  const cbmContext = useContext(CbmContext);
  const { stores, portalUser, submittedData, errorCode } = cbmContext;

  const [bonusData, setBonusData] = useState({
    employee: {
      employeeNumber: '',
      employeeFirst: '',
      employeeMiddle: '',
      employeeLast: '',
      employeeSecondLast: '',
    },
    bonuses: [
      {
        date: null,
        store: null,
        bonus: null,
      },
    ],
    comments: '',
    sig: null,
    portalUser,
  });

  // Use unified form setup hook
  const {
    validationErrors,
    getArrayFieldError,
    hasArrayFieldError,
    clearArrayItemErrors,
    getFieldError,
  } = useFormSetup({
    formName: 'bonus',
    formData: bonusData,
    setFormData: setBonusData,
    setPayLoad,
    setFormError,
    submittedData,
    errorCode,
  });

  const changeEmpInfo = useCallback((e) => {
    const { name, value } = e.target;
    setBonusData((prev) => ({
      ...prev,
      employee: { ...prev.employee, [name]: value },
    }));
  }, []);

  const updateBonuses = useCallback(
    (e, index) => {
      const { name, value } = e.target;
      setBonusData((prev) => {
        const bonusTemp = [...prev.bonuses];
        if (name === 'bonus-store') {
          bonusTemp[index].store = findStoreById(stores, value);
        } else {
          bonusTemp[index][name] = value;
        }
        return { ...prev, bonuses: bonusTemp };
      });
    },
    [stores]
  );

  const addBonus = useCallback(() => {
    setBonusData((prev) => ({
      ...prev,
      bonuses: [...prev.bonuses, { date: '', store: null, bonus: '' }],
    }));
  }, []);

  const removeBonus = useCallback(
    (index) => {
      clearArrayItemErrors('bonuses', index);
      setBonusData((prev) => ({
        ...prev,
        bonuses: prev.bonuses.filter((_, i) => i !== index),
      }));
    },
    [clearArrayItemErrors]
  );

  const setPayMissed = useCallback((e) => {
    const { value } = e.target;
    setBonusData((prev) => ({ ...prev, comments: value }));
  }, []);

  return (
    <Fragment>
      <div className="heading">
        <h1>Bonus</h1>
      </div>
      {errMsg && (
        <div className="error-message-container">
          <p className="error-message">{errMsg}</p>
          <ValidationErrors errors={validationErrors} />
        </div>
      )}
      <fieldset>
        <legend>Employee Info</legend>
        <EmployeeInfo
          payload={bonusData}
          changeEmpInfo={changeEmpInfo}
          getFieldError={getFieldError}
          errMsg={errMsg}
        />
      </fieldset>
      <fieldset className="bonusDates">
        <legend>Bonus Dates</legend>

        {bonusData.bonuses.map((bonus, index) => {
          return (
            <Fragment key={'bonusDate_' + index + 1}>
              <div id="bonusDate">
                <div
                  className={
                    errMsg && hasArrayFieldError('bonuses', index, 'date')
                      ? 'date error'
                      : 'date'
                  }
                >
                  <label className="required">Date</label>
                  <input
                    type="date"
                    name="date"
                    required
                    value={bonus.date || ''}
                    onChange={(e) => updateBonuses(e, index)}
                  />
                  {errMsg && getArrayFieldError('bonuses', index, 'date') && (
                    <span className="error-text">
                      {getArrayFieldError('bonuses', index, 'date')}
                    </span>
                  )}
                </div>
                <div className="bonus-location">
                  <Store
                    storeId={'bonusLocationId'}
                    storeValue={bonus.store?.id}
                    storeList={stores}
                    header="Location"
                    elementName="bonus-store"
                    changeStoreInfo={updateBonuses}
                    index={index}
                  />
                  {errMsg &&
                    getArrayFieldError('bonuses', index, 'store.id') && (
                      <span className="error-text">
                        {getArrayFieldError('bonuses', index, 'store.id')}
                      </span>
                    )}
                </div>
                <div
                  className={
                    errMsg && hasArrayFieldError('bonuses', index, 'bonus')
                      ? 'amount error'
                      : 'amount'
                  }
                >
                  <label className="required">Amount</label>
                  <input
                    type="number"
                    name="bonus"
                    required
                    value={bonus.bonus || ''}
                    onChange={(e) => updateBonuses(e, index)}
                  />
                  {errMsg && getArrayFieldError('bonuses', index, 'bonus') && (
                    <span className="error-text">
                      {getArrayFieldError('bonuses', index, 'bonus')}
                    </span>
                  )}
                </div>
              </div>
              <div className="bonus-add-remove-btns">
                <div className="add">
                  <button onClick={() => addBonus()}>Add Bonus</button>
                </div>
                <div className="remove">
                  <button onClick={() => removeBonus(index)}>
                    {' '}
                    Remove Bonus
                  </button>
                </div>
              </div>
            </Fragment>
          );
        })}
      </fieldset>
      <fieldset className="bonusInfo">
        <legend>Bonus Info</legend>
        <Comment commentsId={'bonusInfoId'} onHandleChange={setPayMissed} />
      </fieldset>
    </Fragment>
  );
};
// eslint-disable-next-line
Bonus.propTypes = {};

export default Bonus;
